import { useEffect } from 'react';
import { runtimeEnvironment } from '../config/environment';

interface EnvConfig {
    bgColor: string;
    label: string;
}

const ENV_CONFIGS: Partial<Record<string, EnvConfig>> = {
    'dev-local': { bgColor: '#dbeafe', label: 'LOCAL' },
    'test': { bgColor: '#fef9c3', label: 'TEST' },
    'cert': { bgColor: '#dcfce7', label: 'CERT' },
};

export function EnvironmentWatermark() {
    const envConfig = ENV_CONFIGS[runtimeEnvironment];

    useEffect(() => {
        if (!envConfig) return;

        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="125" height="125"><text x="55" y="55" transform="rotate(-45 55 55)" text-anchor="middle" dominant-baseline="middle" font-size="40" font-family="system-ui,sans-serif" font-weight="bold" fill="rgba(0,0,0,0.07)" letter-spacing="4">${envConfig.label}</text></svg>`;
        const encoded = encodeURIComponent(svg);
        const bgImage = `url("data:image/svg+xml,${encoded}")`;

        const style = document.createElement('style');
        style.id = 'env-watermark-style';
        style.textContent = `
            :root { --color-background: ${envConfig.bgColor}; }
            div:has(> main), body {
                background-image: ${bgImage};
                background-repeat: repeat;
                background-size: 125px 125px;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.getElementById('env-watermark-style')?.remove();
        };
    }, []);

    return null;
}
